import { NumberFormat } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { LocaleIdentifier } from '../../../../../../../../../../../../types/localeIdentifier'
import { useInvoiceEditorDocumentType } from '../../../../../../../../hooks/useInvoiceEditorDocumentType'
import { InvoiceSummaryLine } from '../InvoiceSummaryLine'

interface DepositDeductionProps {
  currency: string
  // Positive amount. A final invoice subtracts the deposit; a credit note has negative lines, so it adds it back.
  depositGrossTotal: number
  locale: LocaleIdentifier
}

export const DepositDeduction = ({ currency, depositGrossTotal, locale }: DepositDeductionProps): ReactElement => {
  const { t } = useTranslation()
  const { isCreditNote } = useInvoiceEditorDocumentType()

  const sign = isCreditNote ? '' : '-'

  return (
    <InvoiceSummaryLine
      label={t('external_invoices.editor.deposit_summary.deposit_incl_vat')}
      text={`${sign}${NumberFormat.getCurrencyNumber(depositGrossTotal, currency, locale)}`}
    />
  )
}
